import React from "react";
import { ErrorIcon } from "@echo-health/icons-web";
import styled from "../../styled";
import withMargin, { WithMarginProp } from "../../styled/withMargin";
import Icon from "../../components/Icon";
import { Text } from "./Text";

const Banner = styled.div<WithMarginProp>`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-gap: 12px;
  background: ${p => p.theme.color.white};
  padding: ${p => p.theme.spacing.m};
  border: 2px solid ${p => p.theme.color.red20};
  border-radius: ${p => p.theme.misc.borderRadius};
  ${withMargin};
`;

const Children = styled.div`
  margin-top: ${p => p.theme.spacing.s};
`;

interface ErrorBannerProps extends WithMarginProp {
  className?: string;
  title: string;
  children?: React.ReactNode;
}

export function ErrorBanner({ title, children, ...props }: ErrorBannerProps) {
  return (
    <Banner {...props}>
      <Icon type={ErrorIcon} color="red60" />
      <div>
        <Text isBold={true}>{title}</Text>
        {children && <Children>{children}</Children>}
      </div>
    </Banner>
  );
}
